import React from 'react'
import Breadcrumbs from '../Breadcrumbs'

const DefaultBreadcrumbsPharma = ({
  geo_parent,
  geo_id,
  geo_type,
  dashboardType,
}) => {
  return (
    <Breadcrumbs>
      {geo_type === 'NAT' && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={'/Home'}
          />
          <Breadcrumbs.Item className={'label'} key={'US'} label={'US'} last />
        </>
      )}
      {geo_type === 'STATE' && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={
              dashboardType.toLowerCase() === 'flu' ? '/home' : '/Dashboard'
            }
            first
          />
          <Breadcrumbs.Item
            key="US"
            label="US"
            href={
              dashboardType.toLowerCase() === 'flu'
                ? '/forecasts/flumap'
                : '/' + dashboardType + 'Dashboard'
            }
          />
          <Breadcrumbs.Item
            className={'label'}
            key={geo_id}
            label={geo_id}
            last
          />
        </>
      )}
      {(geo_type === 'MSA' || geo_type === 'COUNTY' || geo_type === 'ZIP3') && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={
              dashboardType.toLowerCase() === 'flu' ? '/home' : '/Dashboard'
            }
            first
          />
          <Breadcrumbs.Item
            key="US"
            label="US"
            href={
              dashboardType.toLowerCase() === 'flu'
                ? '/forecasts/flumap'
                : '/' + dashboardType + 'Dashboard'
            }
          />
          {geo_type !== 'ZIP3' && (
            <Breadcrumbs.Item
              key={geo_parent}
              last={geo_type === 'ZIP3'}
              href={'/' + dashboardType + 'StateDashboard/STATE/' + geo_parent}
              label={geo_parent}
            />
          )}

          {geo_type === 'ZIP3' && geo_id !== undefined && dashboardType.toLowerCase() === 'flu' && (            
            <Breadcrumbs.Item
              key={geo_parent}
              last={true}
              href={
                '/' + dashboardType + 'StateDashboard/STATE/' + geo_parent
              }
              label={`${geo_parent}, ${geo_id}`}
            />
          )}
        </>
      )}
    </Breadcrumbs>
  )
}

export default DefaultBreadcrumbsPharma
